import styled from 'styled-components';
import { Input } from 'antd';

export default styled(Input)``;

export const { TextArea } = Input;
